export * from "./product-details";
